interface Filters{status:boolean, btn:HTMLElement, filter:string, exists:boolean, targetGroup:string}
interface Cards{status:boolean, card:HTMLElement, filter:string[]}

export default class Filter {

    private filter:Filters[] = [];
    private cards:Cards[] = [];

    public constructor(){

       // this.showElemnts();

let btn = document.querySelectorAll('.pl_btn');

for(let i = 0; i < btn.length; i++){


    let ele:HTMLElement = btn[i] as HTMLElement;

    this.filter[i] = {
        status:false, 
        btn:ele,
        filter:ele.getAttribute('attr') as string,
        exists:false,
        targetGroup:ele.getAttribute('group') as string
    }; 



    this.filter[i].btn.addEventListener('click', (e)=>{
    
        console.log(this.filter[i]);

        
       /* if(this.filter[i].filter == 'all-cat' || this.filter[i].filter == 'all-lang'){
           

            for(let r = 0; r < this.filter.length; r++){
                this.filter[r].status = false;
                this.filter[r].btn.classList.remove('active');
            }

            this.filter[i].status = true;  
            this.filter[i].btn.classList.add('active');

        }*/


        /*else if(this.filter[i].status){
            this.filter[i].status = false;  
            this.filter[i].btn.classList.remove('active');
        }else{

            this.filter[i].status = true;  
            this.filter[i].btn.classList.add('active');
        }     */       


        if(this.filter[i].targetGroup == 'target' || this.filter[i].targetGroup == 'lang'){
            
            
            //this.targetGroup(i);
       

            


            for(let u = 0; u < this.filter.length; u++){

                if(u != i && this.filter[u].targetGroup == this.filter[i].targetGroup){
                    this.filter[u].status = false;  
                    this.filter[u].btn.classList.remove('active');
                }
                

                if (u == i && this.filter[u].targetGroup == this.filter[i].targetGroup) {
                    this.filter[u].status = true;  
                    this.filter[u].btn.classList.add('active');
                }


                        
            }
       
            /*
            
            for(let u = 0; u < this.filter.length; u++){

    if(u != i){

    this.filter[i].status = false;  
    this.filter[i].btn.classList.remove('active');

    }else{
        this.filter[i].status = true;  
        this.filter[i].btn.classList.add('active');
    }
            
            */ 
       
       
        }


        this.showElemnts();
    
     });

}

let acordionSection:HTMLElement =  document.querySelectorAll('.with-filter')[0] as HTMLElement;


let items = acordionSection.querySelectorAll('.card');
for (let i = 0; i < items.length; i++){

    let item = items[i] as HTMLElement;

    let attr:string = item.getAttribute('coursecategorie') as string;

    this.cards[i] = {
        status:true,
        card: item,
        filter: this.idontknow(attr) 
    }

}



//console.log(this.filter);



    }

 private idontknow(attr:string | null):string[]{
     let strArray: string[] = [];

     if(attr != null){
        strArray =  attr.split(' ');
     }

     return strArray;
 }


    private targetGroup(item:number){

for(let i = 0; i < this.filter.length; i++){

    if(i != item){

    this.filter[i].status = false;  
    this.filter[i].btn.classList.remove('active');

    }else{
        this.filter[i].status = true;  
        this.filter[i].btn.classList.add('active');
    }
}


    }

    private filterExist(){
        for (let i = 0; i < this.filter.length; i++){

            this.filter[i].exists = false;

            for (let x = 0; x < this.cards.length; x++){
                if(this.cards[x].status == true){
                    for (let y = 0; y < this.cards[i].filter.length; y++){
                        
                        if(this.filter[i].filter == this.cards[x].filter[y]){
                            this.filter[i].exists = true;
                            //console.log(this.filter[i].filter + ' = ' + this.cards[x].filter[y]);
                        }

                    }
                }
            }

            let cat:HTMLElement = document.querySelector('.cat-'+this.filter[i].filter) as HTMLElement;

            if(this.filter[i].exists){
                this.filter[i].exists = true;
                this.filter[i].btn.classList.remove('inactive');
               
                if(cat != null){
                cat.style.display = 'block';
                }
            }else{
                this.filter[i].exists = false;
                this.filter[i].btn.classList.add('inactive');

                if(cat != null){
                cat.style.display = 'none';
                }
            }

        }
    }


    private showElemnts(){


    

        let coursecategorie:string[] = [];

        for (let i = 0; i < this.filter.length; i++){

            if(this.filter[i].status){
               
                if(this.filter[i].filter){
                    let str:string = this.filter[i].filter as string;
                    coursecategorie.push(str);
                }
            }

        }



        for(let i = 0; i < this.cards.length; i++){
            let count = 0;
            let issetCategorie:boolean = false;
    

            for (let x = 0; x < this.cards[i].filter.length; x++){
        
                if(this.mustTrue(this.cards[i].filter[x], coursecategorie)){
                    count++;
                }
            
                
                if(count == coursecategorie.length){
                    issetCategorie = true;
                    break;    
                }           
            
            }


        

            if(!issetCategorie){
                this.cards[i].card.style.display = 'none';


                    let parent = this.cards[i].card.parentElement;

                if(parent != undefined){
                    parent.style.display = 'none';
                }




                this.cards[i].status = false;
            }else{
                this.cards[i].card.style.display = 'inline-flex';

                let parent = this.cards[i].card.parentElement;

                if(parent != undefined){
                    parent.style.display = 'flex';
                }

                this.cards[i].status = true;
            }
        


        }    

        this.filterExist();

    }


    private mustTrue(categorie:string, categorielist:string[]): boolean{

        //let coursecategorie:string[] = ['admins', 'security'];

        let catExists:boolean = false;

        for(let i = 0; i < categorielist.length; i++){


            if (categorie == categorielist[i]) {
                catExists = true;
                break;
            }

        }


        return catExists;

    }


}